require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-for-womens-history-month-were-celebrating-the-women-of-code-fellows.json") })
        }
      }, "path---blog-for-womens-history-month-were-celebrating-the-women-of-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-for-womens-history-month-were-celebrating-the-women-of-code-fellows!./.cache/json/blog-for-womens-history-month-were-celebrating-the-women-of-code-fellows.json
// module id = 813
// module chunks = 231608221292675